import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
// import * as moment from 'moment';
 import { ToastrService } from 'ngx-toastr';
import { BlogService } from 'src/app/api/module/erp/services/blog/blog.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit , AfterViewInit{
  listaBlogsPaginated: any;
  itemPostDetails: any;
  date: Date = new Date();
  postDestaque: any;
  textoFormatado!: string; 
  isLaoding: boolean=true;

  constructor( 
    private router: Router,
    private toastr: ToastrService, 
    private blogItens: BlogService
  ) { }
  ngAfterViewInit(): void {
    this.getPosts();
  }

  ngOnInit(): void {
    this.getPosts();
  }


getWeekDescription(date: string): any {
    
 const date1 = new Date(Date.now());
const date2 = new Date(date);
 const differenceInMilliseconds = date1.getTime() - date2.getTime();
const differenceInWeeks = Math.round(differenceInMilliseconds / (7 * 24 * 60 * 60 * 1000));
  
    switch (differenceInWeeks) {
      case 1:
        return 'Há 1 Semana';
      case 2:
        return 'Há 2 Semanas';
      case 3:
        return 'Há 3 Semanas';
      case 4:
        return 'Há 4 semana';
      default:
        return 'Há + de 4 Semanas';
    }
  }

  sliceText(text: string) {
      return text.slice(0,154)+"..."; 
    
  }

  toHTML(input:any) : any {
      let valor =  String(new DOMParser().parseFromString(input, "text/html").documentElement.textContent);
    return this.sliceText(valor);
  }

  getPosts() {
    this.blogItens.onGetPost().subscribe({
      next: (data: any) => {
        setTimeout(() => {
          this.listaBlogsPaginated = data.filter((x: { descricao: null; }) => x.descricao == null);
          this.postDestaque = data[0];
          this.isLaoding = false;
        }, 1000);
      },
      error: (e: any) => {
        console.log("Erro ao listar os blogs", e);
      }
    });
  }
   
  postDetails(id:string) {
      this.blogItens.onGetPostById(id).subscribe((data) => {
        this.itemPostDetails = data;
      });
     
  }  
}
 
